import React, { Component, Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import { Icon, Layout, Alert, Divider, Popover, Badge, Row, Col } from 'antd';
import { BotsView } from './Bots';
import { BotView } from './Bot';
import { SettingsView } from './Settings';
import { inject, observer } from 'mobx-react/index';
import { GettingStartedView } from './GettingStarted';
import { StratCenterView } from './StratCenter';
import { MainMenu } from './MainMenu';
import { SubscriptionView } from './SubscriptionsView';
import { LeverageBotView } from './OdysseyBot';
import { MakoBotView } from './MakoBot';
import { StrategiesView } from './Strategies';
import { CopyTradingView } from './CopyTradingView';
const { Content, Footer, Header } = Layout;

@inject('store')
@observer
export class AccountView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loggedIn: false,
            collapsed: false
        };
    }

    componentDidMount() {
        this.props.store.getBaseConfig();

        this.props.store.userStore.registerAutoLogout();
    }

    toggle() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    renderNotification() {
        if (this.props.store.baseConfig.notification.enabled) {
            return (
                <Alert
                    banner
                    closable
                    message={this.props.store.baseConfig.notification.title}
                    description={this.props.store.baseConfig.notification.description}
                    type="info"
                    showIcon
                />
            );
        }
        return null;
    }

    renderBillingNotification() {
        if (!this.props.store.userStore.currentUser.country) {
            return (
                <Alert
                    message={'Your billing information is incomplete'}
                    closeText="Fix now"
                    onClose={() => {
                        this.props.history.push('/a/my-account');
                    }}
                    type="warning"
                    showIcon
                />
            );
        }
        return null;
    }

    renderAnnouncements() {
        let unreadCount = 0;
        const baseConfig = this.props.store.baseConfig;
        baseConfig.annoucements.forEach(a => {
            if (a.published_at > this.props.store.userStore.currentUser.last_read_announcement) {
                unreadCount++;
            }
        });

        return (
            <div style={{ position: 'absolute', right: 25 }}>
                <Popover
                    placement="bottomRight"
                    trigger="click"
                    title={'Announcements'}
                    content={baseConfig.annoucements
                        .slice()
                        .reverse()
                        .map((r, i) => {
                            return (
                                <div key={i} style={{ width: 350 }}>
                                    <b>{r.title}</b> {r.description}&nbsp;
                                    {r.url ? (
                                        <a href={r.url} target={'_blank'}>
                                            Read More
                                        </a>
                                    ) : null}
                                    <Divider />
                                </div>
                            );
                        })}
                    onClick={() => {
                        this.props.store.userStore.updateProfile({
                            last_read_announcement: Date.now()
                        });
                    }}
                >
                    <Badge count={unreadCount}>
                        <Icon
                            style={{ fontSize: 21, position: 'relative', bottom: -5 }}
                            type="notification"
                        />
                    </Badge>
                </Popover>
            </div>
        );
    }

    render() {
        if (!this.props.store.baseConfig || !this.props.store.botStore.initialDataLoaded)
            return null;

        if (this.props.store.baseConfig.disable_ui) {
            return (
                <Row
                    type="flex"
                    justify="start"
                    align="middle"
                    style={{ height: '100%' }}
                    gutter={24}
                >
                    <Col xs={{ span: 0 }} md={{ span: 12 }} style={{ height: '100%' }}>
                        <div className="authentication-scene" />
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 8, offset: 2 }}>
                        <div className={'authentication-form'}>
                            <Alert
                                style={{ marginBottom: 10 }}
                                message="Apex Scheduled Maintenance"
                                description={this.props.store.baseConfig.maitenance_description}
                                type="warning"
                                showIcon
                            />
                        </div>
                    </Col>
                </Row>
            );
        }

        return (
            <Fragment>
                {this.renderNotification()}

                <Layout style={{ minHeight: '100vh' }}>
                    <Header className={'no-print'}>
                        {this.renderAnnouncements()}
                        <div
                            style={{
                                display: window.screen.width < 500 ? 'none' : 'inline-block',
                                marginRight: '10px'
                            }}
                        >
                            <span className={'heading-title'}>
                                <img src={'/logo.png'} height="40px" alt="Apex Trader Logo" />
                            </span>
                        </div>
                        <div
                            style={{
                                display: 'inline-block',
                                marginRight: '10px',
                                width: window.screen.width < 500 ? '55%' : '70%'
                            }}
                        >
                            <MainMenu />
                        </div>
                    </Header>

                    <Layout>
                        <Layout>
                            <Content style={{ margin: '16px 16px', minHeight: 280 }}>
                                {this.renderBillingNotification()}
                                <Switch>
                                    <Route
                                        path="/a/getting-started"
                                        component={GettingStartedView}
                                    />
                                    <Route path="/a/bots" component={BotsView} />
                                    <Route path="/a/bot/:id" component={BotView} />
                                    <Route path="/a/odyssey/:id" component={LeverageBotView} />
                                    <Route path="/a/mako/:id" component={MakoBotView} />
                                    <Route path="/a/strategies" component={StrategiesView} />
                                    <Route path="/a/my-account" component={SettingsView} />
                                    <Route path="/a/strat-center" component={StratCenterView} />
                                    <Route path="/a/subscriptions" component={SubscriptionView} />
                                    <Route path="/a/copytrading" component={CopyTradingView} />
                                </Switch>
                                <Footer
                                    className="no-print"
                                    style={{ textAlign: 'center', fontSize: 12 }}
                                >
                                    &copy; 2020 Apex Trader Software Ltd Company No. 09757060 <br />
                                </Footer>
                            </Content>
                        </Layout>
                    </Layout>
                </Layout>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/index.js